export default {
  SET_SIP_SERVER(state, sip_server) {
    state.sip_server = sip_server;
  },
};
